import type { IApiConfig } from "@hopper-b2b/types";

export const PATH_HOME = "/";
// TODO: remove temporary basic auth once ready (see https://hopper-jira.atlassian.net/browse/BP-98)
export const PATH_BASIC_AUTH = PATH_HOME + "basicAuth/";
export const PATH_FLIGHTS = PATH_HOME + "flights/";
export const PATH_FLIGHTS_REBOOK = `${PATH_FLIGHTS}rebook/`;
export const PATH_FLIGHTS_REBOOK_SUMMARY = `${PATH_FLIGHTS_REBOOK}summary/`;
export const PATH_FLIGHTS_BOOK = PATH_FLIGHTS + "book/";
export const PATH_FLIGHTS_FREEZE = PATH_FLIGHTS + "freeze/";
export const PATH_FLIGHTS_FREEZE_PURCHASE = PATH_FLIGHTS_FREEZE + "purchase/";
export const PATH_FLIGHTS_FREEZE_OVERVIEW = PATH_FLIGHTS_FREEZE + "overview/";
export const PATH_FLIGHTS_SEARCH = PATH_FLIGHTS + "search/";
export const PATH_FLIGHTS_BOOK_CONFIRMATION = PATH_FLIGHTS_BOOK + "confirm/";
export const PATH_HOTELS = PATH_HOME + "hotels/";
export const PATH_HOTELS_BOOK = PATH_HOTELS + "book/";
export const PATH_HOTELS_SEARCH = PATH_HOTELS + "search/";
export const PATH_HOTELS_BOOK_CONFIRMATION = PATH_HOTELS_BOOK + "confirm/";
export const PATH_CARS = PATH_HOME + "cars/";
export const PATH_CARS_SEARCH = PATH_CARS + "search/";
export const PATH_CARS_AVAILABILITY = PATH_CARS + "availability/";
export const PATH_CARS_BOOK = `${PATH_CARS}book/`;
export const PATH_CARS_BOOK_CONFIRMATION = PATH_CARS_BOOK + "confirm/";
export const PATH_TRIPS = PATH_HOME + "trips/";
export const PATH_DISRUPTION_EXERCISE = PATH_TRIPS + "disruption/exercise/";
export const PATH_TERMS = PATH_HOME + "terms/";
export const PRICE_DROP_PROTECTION = PATH_TERMS + "price-drop-protection/";
export const BEST_PRICE_GUARANTEE = PATH_TERMS + "best-price-guarantee/";
export const PRICE_FREEZE = PATH_TERMS + "frozen-prices/";
export const PRICE_PREDICTION_PRICE_WATCH =
  PATH_TERMS + "price-prediction-price-watch/";
export const PATH_SITE_TERMS_OF_USE = PATH_HOME + "site-terms-of-use/";
export const PATH_AUTH = `${PATH_HOME}auth/`;
export const PATH_AUTH_FTUX = `${PATH_AUTH}ftux/`;
export const PATH_AUTH_START_SESSION = `${PATH_AUTH}startsession/`;
export const PATH_AUTH_INVALID_SESSION = `${PATH_AUTH}invalidsession/`;
export const PATH_AUTH_LOGOUT = `${PATH_AUTH}logout/`;
export const PATH_LUXURY_HOTELS = PATH_HOME + "luxury-hotels/";
export const PATH_LUXURY_HOTELS_SEARCH = PATH_LUXURY_HOTELS + "search/";
export const PATH_EXCHANGE = `${PATH_FLIGHTS}exchange`;
export const PATH_RYANAIR_CALLBACK = "/confirm-ryanair";
export const FINTECH_TERMS_CONDITIONS_LINK =
  "https://hts.hopper.com/legal/what-are-hts-add-ons";

export const PATH_GEN_AUTH = `/api/v0/auth/`;
export const PATH_GEN_AUTH_START_SESSION = `${PATH_GEN_AUTH}startSession`;

export const HIDDEN_FOOTER_PATHS = [
  PATH_FLIGHTS_REBOOK,
  PATH_FLIGHTS_REBOOK_SUMMARY,
  `${PATH_HOTELS}availability/`,
  PATH_FLIGHTS_FREEZE_PURCHASE,
  PATH_FLIGHTS_FREEZE_OVERVIEW,
  PATH_RYANAIR_CALLBACK,
];

export const HIDDEN_FOOTER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const NO_FOOTER_PADDING_PATHS: string[] = [];

export const NO_FOOTER_PADDING_UNPROTECTED_PATHS: string[] = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const HIDDEN_HEADER_PATHS = [
  `${PATH_FLIGHTS}shop/`,
  `${PATH_FLIGHTS}book/`,
  PATH_FLIGHTS_REBOOK,
  PATH_FLIGHTS_REBOOK_SUMMARY,
  PATH_EXCHANGE,
  `${PATH_FLIGHTS_FREEZE_PURCHASE}`,
  PATH_FLIGHTS_FREEZE,
  `${PATH_HOTELS}availability/`,
  `${PATH_HOTELS}shop/`,
  `${PATH_HOTELS}book/`,
  PATH_CARS_AVAILABILITY,
  PATH_CARS_BOOK,
  `${PATH_CARS}shop/`,
  PATH_FLIGHTS_FREEZE_OVERVIEW,
  PATH_EXCHANGE,
  PATH_TRIPS,
  PATH_RYANAIR_CALLBACK,
];

export const DISPLAY_HOMEPAGE_TAKEOVER_PATHS = [
  PATH_FLIGHTS,
  PATH_HOTELS,
  PATH_CARS,
  PATH_HOME,
];

export const HIDDEN_FOOTER_SEARCH_MOBILE = [
  PATH_FLIGHTS_SEARCH,
  PATH_HOTELS_SEARCH,
  PATH_CARS_SEARCH,
  PATH_EXCHANGE,
  PATH_LUXURY_HOTELS_SEARCH,
  PATH_TRIPS,
  PATH_FLIGHTS_BOOK,
  PATH_FLIGHTS_REBOOK,
];

export const UNPROTECTED_PATHS = [
  PATH_AUTH,
  // PATH_TERMS,
  // PATH_TERMS_OF_SERVICE,
  // PATH_SITE_TERMS_OF_USE,
  // PRICE_DROP_PROTECTION,
  // BEST_PRICE_GUARANTEE,
  // PRICE_PREDICTION_PRICE_WATCH,
  // PRICE_FREEZE,
];

export const HIDDEN_HEADER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const HIDDEN_BANNER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
  ...UNPROTECTED_PATHS,
];

export const POSITION_FIXED_FOOTER_PATHS: string[] = [];

export const apiVersionPrefix = "/api/v0";

export const fetchUserInfoPath = `${apiVersionPrefix}/user/getInfo`;
export const analyticsApiPrefix = `${apiVersionPrefix}/tracking`;
export const rewardsApiPrefix = `${apiVersionPrefix}/rewards`;

export const experimentsApiPrefix = `${apiVersionPrefix}/experiments`;
export const takeoversApiPrefix = `${apiVersionPrefix}/takeovers`;

export const apiConfig: IApiConfig = {
  experimentsApiPrefix,
  rewardsApiPrefix,
  takeoversApiPrefix,
  analyticsApiPrefix,
  fetchUserInfoPath,
};
